import React from 'react'

export const DetailRole = () => {
  return (
    <div>Detail</div>
  )
}
